import dataService from "../../../helpers/dataService";

/**
 * Récupère le contexte nécessaire pour inscrire un allocataire en EP
 * @param {string} allocataireId - ID de l'allocataire
 * @returns {Promise} Contexte d'inscription avec organismes, types de sanction et historique
 */
export const fetchEpInscriptionContext = (allocataireId) => {
  return new Promise((resolve, reject) => {
    dataService.post(
      "eps/recuperer-contexte-inscription",
      { allocataireId },
      (response) => {
        // MOCK: Injection de données avec le nouveau format
        // À retirer quand l'API renverra ces données
        const enrichedResponse = {
          ...response,
          // motifsPrincipaux: [
          //   {
          //     id: "REFUS_ELABORER_ACTUALISER_CONTRAT",
          //     erreur:
          //       "Ce motif n'est pas disponible pour cet allocataire car il n'a pas de contrôle en cours",
          //     typesSanctions: [{ id: "SUSPENSION" }, { id: "SUPPRESSION" }],
          //   },
          //   {
          //     id: "NON_RESPECT_DISPOSITIONS_CONTRAT",
          //     typesSanctions: [{ id: "SUSPENSION" }, { id: "SUPPRESSION" }],
          //   },
          //   {
          //     id: "REFUS_OFFRE_RAISONNABLE_EMPLOI",
          //     typesSanctions: [{ id: "SUSPENSION" }, { id: "SUPPRESSION" }],
          //   },
          //   {
          //     id: "REFUS_SOUMETTRE_CONTROLES",
          //     typesSanctions: [
          //       {
          //         id: "SUSPENSION",
          //         erreur: "Indisponible pour ce motif",
          //       },
          //       { id: "SUPPRESSION" },
          //     ],
          //   },
          // ],
        };
        resolve(enrichedResponse);
      },
      (error) => {
        reject(error);
      },
    );
  });
};
